module.exports = __webpack_public_path__ + "static/media/wrighter.02fdae43.jpg";